import { render, staticRenderFns } from "./BetaTag.vue?vue&type=template&id=e330615e&"
import script from "./BetaTag.vue?vue&type=script&lang=js&"
export * from "./BetaTag.vue?vue&type=script&lang=js&"
import style0 from "./BetaTag.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports